import React, { useState } from "react";
import { Button, Form, Grid, Header, Modal } from "semantic-ui-react";
// Images
import SlidingPane from "react-sliding-pane";

import { connect } from "react-redux";
import {
  createGallery,
  updateGallery,
} from "../../../../../../redux/actions/gallery";
import DropZone from "../../../../../../components/DropZone";
import "react-sliding-pane/dist/react-sliding-pane.css";
import ErrorMessage from "../../../../../../components/ErrorMessage";

const EditGallerySidePain = ({ gallery, children, update, create }) => {
  const [loading, setLoading] = useState(false);
  const [sidePainOpen, setSidePainOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [error, setError] = useState(null);

  const [id] = useState(gallery._id);
  const [imageUrl] = useState(gallery.image_url || null);
  const [file, setFile] = useState(null);
  const [name, setName] = useState(gallery.name || "");
  const [nameLowerCase, setNameLowercase] = useState(
    gallery.name_lower_case || "",
  );
  const [slug, setSlug] = useState(gallery.slug || "");
  const [about, setAbout] = useState(gallery.about || "");
  const [phone, setPhone] = useState(gallery.phone || "");
  const [email, setEmail] = useState(gallery.email || "");
  const [websiteUrl, setWebsiteUrl] = useState(gallery.website_url || "");
  const [instagramUsername, setInstagramUsername] = useState(
    gallery.instagram_username || "",
  );
  const [twitterUsername, setTwitterUsername] = useState(
    gallery.twitter_username || "",
  );

  const onSubmit = async () => {
    setError(null);
    setLoading(true);

    const data = {
      name,
      file,
      name_lower_case: nameLowerCase,
      slug,
      about,
      website_url: websiteUrl,
      instagram_username: instagramUsername,
      twitter_username: twitterUsername,
    };

    var formData = new FormData();

    for (var key in data) {
      if (data[key]) {
        formData.append(key, data[key]);
      }
    }

    try {
      if (id) {
        await update(id, formData);
      } else {
        await create(formData);
      }

      setModalOpen(true);
    } catch (e) {
      setError(e);
    }

    setLoading(false);
  };

  return (
    <>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="overlay"
        isOpen={sidePainOpen}
        title={
          <Grid stackable>
            <Grid.Row>
              <Grid.Column width={16}>
                <Header
                  floated={"left"}
                  content={id ? "Edit Gallery" : "Create Gallery"}
                />

                <Button
                  primary
                  content={"Save"}
                  floated={"right"}
                  loading={loading}
                  onClick={onSubmit}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        }
        onRequestClose={() => setSidePainOpen(false)}
      >
        <Form fluid>
          {error && <ErrorMessage error={error} />}

          <Modal open={modalOpen}>
            <Modal.Header size="huge" content="Thank you" />
            <Modal.Content>
              <p>
                Our team will review the proposed changes and make the necessary
                adjustments.
              </p>
            </Modal.Content>
            <Modal.Actions>
              <Button
                primary
                content="Okay"
                onClick={() => {
                  setModalOpen(false);
                  setSidePainOpen(false);
                }}
              />
            </Modal.Actions>
          </Modal>

          <Form.Group>
            <Form.Field width={4}>
              <label>Image</label>
            </Form.Field>
            <Form.Field width={12}>
              <DropZone
                onDrop={(acceptedFiles) => setFile(acceptedFiles[0])}
                multiple={false}
                accept="image/*"
                icon={"image"}
                image={(file && file.preview) || imageUrl}
                placeholder={"Drag gallery image here or click to upload"}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group>
            <Form.Field width={4}>
              <label>Name</label>
            </Form.Field>
            <Form.Input
              fluid
              defaultValue={name}
              width={12}
              placeholder="Name"
              autoComplete={"off"}
              onChange={(e, { value }) => setName(value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Field width={4}>
              <label>Website</label>
            </Form.Field>
            <Form.Input
              fluid
              name="website_url"
              defaultValue={websiteUrl}
              width={12}
              placeholder="Website"
              autoComplete={"off"}
              onChange={(e, { value }) => setWebsiteUrl(value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Field width={4}>
              <label>Email & Phone</label>
            </Form.Field>
            <Form.Input
              fluid
              defaultValue={email}
              width={6}
              placeholder="Email"
              autoComplete={"off"}
              onChange={(e, { value }) => setEmail(value)}
            />
            <Form.Input
              fluid
              defaultValue={phone}
              width={6}
              placeholder="Phone"
              autoComplete={"off"}
              onChange={(e, { value }) => setPhone(value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Field width={4}>
              <label>Social</label>
            </Form.Field>
            <Form.Input
              fluid
              defaultValue={instagramUsername}
              width={6}
              placeholder="Instagram Username"
              autoComplete={"off"}
              onChange={(e, { value }) => setInstagramUsername(value)}
            />
            <Form.Input
              fluid
              defaultValue={twitterUsername}
              width={6}
              placeholder="Twitter Username"
              autoComplete={"off"}
              onChange={(e, { value }) => setTwitterUsername(value)}
            />
          </Form.Group>

          <Form.Group>
            <Form.Field width={4}>
              <label>About</label>
            </Form.Field>
            <Form.TextArea
              defaultValue={about}
              width={12}
              placeholder={"About"}
              rows={8}
              autoComplete={"off"}
              onChange={(e, { value }) => setAbout(value)}
            />
          </Form.Group>
        </Form>
      </SlidingPane>

      <div onClick={() => setSidePainOpen(true)}>{children}</div>
    </>
  );
};

const mapStateToProps = ({ firebase }) => ({});

const mapDispatchToProps = (dispatch) => ({
  create: (data) => dispatch(createGallery(data)),
  update: (id, data) => dispatch(updateGallery(id, data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditGallerySidePain);
